import { useState } from "react";
import Image from "components/Elements/Image/Image";
import Icon from "components/Elements/Icon/Icon";
import Button, { ButtonA } from "components/Elements/Button/Button";
import Cursor from "../../../../Reusable/VideoCursor/Cursor/Cursor";
import VideoModal from "components/Reusable/VideoCursor/Modal/VideoModal";
import useMediaQueries from "hooks/useMediaQueries";
import useGetStartedLoginCallback from "../../helpers/useGetStartedLoginCallback";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";
import { useUser } from "contexts/userContext/userContext";
import config from "config";

import generalStyles from "../../styles.module.scss";
import styles from "./styles.module.scss";

const VideoBanner = () => {
  const { getHtmlByKey, getTextByKey, getDirection } = useContent();
  const { setModal } = useModal();
  const { isLoggedIn } = useUser();
  const { desktopCondition } = useMediaQueries();
  const [isHover, setIsHover] = useState(false);
  const handleClick = useGetStartedLoginCallback();

  const openVideoClick = () => {
    setModal({
      modal: VideoModal,
      props: {
        src: "https://www.youtube.com/embed/BRgkjhSFzEQ?autoplay=1",
      },
    });
  };

  return (
    <section
      className={`${styles.videoBanner} ${isHover ? styles.hideCursor : " "}`}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div
        className={
          styles.textSection +
          " " +
          (getDirection() === "rtl" ? `${styles.rtl}` : "")
        }
      >
        <Image name="logo-picker-text" className={styles.pickerLogo} />
        <div className={generalStyles.subTitleLight}>
          {getHtmlByKey("picker-section-1-sub-title")}
        </div>
        <h1 className={generalStyles.titleLight}>
          {getHtmlByKey("picker-section-1-title")}
        </h1>
        <p className={generalStyles.textLight}>
          {getHtmlByKey("picker-section-1-sub-text")}
        </p>
        <div className={styles.buttonContainer}>
          {isLoggedIn() ? (
            <ButtonA
              page="inbox?t=picker"
              title={getTextByKey("get-started")}
              className={generalStyles.button}
              onMouseEnter={() => setIsHover(false)}
              onMouseLeave={() => setIsHover(true)}
            />
          ) : (
            <Button
              onClick={handleClick}
              title={getTextByKey("get-started")}
              className={generalStyles.button}
              onMouseEnter={() => setIsHover(false)}
              onMouseLeave={() => setIsHover(true)}
            />
          )}

          <Button
            className={styles.buttonVideo}
            onMouseEnter={() => setIsHover(false)}
            onMouseLeave={() => setIsHover(true)}
            onClick={openVideoClick}
          >
            <div>
              <Icon name="play" />
            </div>
            {getTextByKey("watch-video-text")}
          </Button>
        </div>
      </div>
      <div className={styles.videoOverlay} />
      <video controls={false} autoPlay muted>
        <source
          src={
            !desktopCondition
              ? `${config.api.resource}/assets/images/picker/banner-mob.mp4`
              : `${config.api.resource}/assets/picker_banner-slow-dark.mp4`
          }
          type="video/mp4"
        />
      </video>
      <Cursor isHover={isHover} color="#ed3867" handleClick={openVideoClick} />
    </section>
  );
};

export default VideoBanner;
